module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Cloud Account Import")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    staticClass: "select-role",
    attrs: {
      "label": _vm.attrText.cloudPlatform,
      "prop": "source"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "change": _vm.changeCloudPlarform
    },
    model: {
      value: (_vm.formData.source),
      callback: function($$v) {
        _vm.formData.source = $$v
      },
      expression: "formData.source"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.aliyun_zh,
      "value": "aliyun"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.aliyun_cn,
      "value": "aliyun_overseas"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.huawei_zh,
      "value": "huaweiyun"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.huawei_cn,
      "value": "huaweiyun_overseas"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.aws_zh,
      "value": "aws"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.aws_cn,
      "value": "aws_overseas"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.volcengine,
      "value": "huoshanyun"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fixed-text",
    attrs: {
      "label": "Access Key",
      "prop": "ak"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.ak
    },
    model: {
      value: (_vm.formData.ak),
      callback: function($$v) {
        _vm.formData.ak = $$v
      },
      expression: "formData.ak"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fixed-text",
    attrs: {
      "label": "Access Secret",
      "prop": "sk"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.sk,
      "type": "password",
      "name": "newPassword",
      "autocomplete": "new-password"
    },
    model: {
      value: (_vm.formData.sk),
      callback: function($$v) {
        _vm.formData.sk = $$v
      },
      expression: "formData.sk"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.area,
      "prop": "region"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "disabled": !_vm.formData.source
    },
    model: {
      value: (_vm.formData.region),
      callback: function($$v) {
        _vm.formData.region = $$v
      },
      expression: "formData.region"
    }
  }, _vm._l((_vm.regions), function(region) {
    return _c('el-option', {
      key: region.RegionId,
      attrs: {
        "label": _vm.$language.current === 'zh_CN' ? region.LocalName : region.LocalNameEn,
        "value": region.RegionId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.scanType,
      "prop": "region"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.is_shield),
      callback: function($$v) {
        _vm.formData.is_shield = $$v
      },
      expression: "formData.is_shield"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_c('translate', [_vm._v("Full Scan")])], 1), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_c('translate', [_vm._v("Block Imported IP")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.scanLoading),
      expression: "scanLoading"
    }],
    staticClass: "scan-btn",
    attrs: {
      "type": "primary",
      "disabled": !_vm.isCanScan
    },
    on: {
      "click": function($event) {
        _vm.scan()
      }
    }
  }, [_c('translate', [_vm._v("Scan")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-header"
  }, [(_vm.$route.query.type == 'ecs') ? _c('span', [_c('translate', [_vm._v("Select The Host")])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.query.type == 'rds') ? _c('span', [_c('translate', [_vm._v("Select The Database")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-select', {
    staticClass: "account-search",
    attrs: {
      "placeholder": "userType"
    },
    on: {
      "change": _vm.initSelect
    },
    model: {
      value: (_vm.searchForm.condition),
      callback: function($$v) {
        _vm.searchForm.condition = $$v
      },
      expression: "searchForm.condition"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.instanceName,
      "value": "instance_name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.instanceId,
      "value": "instance_id"
    }
  }), _vm._v(" "), (_vm.$route.query.type == 'ecs') ? _c('el-option', {
    attrs: {
      "label": _vm.attrText.os,
      "value": "os_type"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.query.type == 'ecs') ? _c('el-option', {
    attrs: {
      "label": "VPC ID",
      "value": "vpc_id"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.query.type == 'rds') ? _c('el-option', {
    attrs: {
      "label": _vm.attrText.type,
      "value": "engine"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.IPAndAddress,
      "value": "ip_address"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    staticClass: "searchInput",
    attrs: {
      "icon": "search",
      "on-icon-click": _vm.scan
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.scan()
      }
    },
    model: {
      value: (_vm.searchForm.text),
      callback: function($$v) {
        _vm.searchForm.text = $$v
      },
      expression: "searchForm.text"
    }
  })], 1)]), _vm._v(" "), (_vm.$route.query.type == 'ecs') ? _c('el-table', {
    staticClass: "instance-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.instanceList,
      "max-height": "400"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45",
      "fixed": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.instanceIdAndName,
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": scope.row.instance_name
          }
        }, [_c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.instance_name))])]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": scope.row.instance_id
          }
        }, [_c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.instance_id))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.os,
      "prop": "os_type",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "VPC ID",
      "prop": "vpc_id",
      "width": "220"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.IPAndAddress,
      "prop": "ip_address",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.port,
      "prop": "port",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          model: {
            value: (scope.row.port),
            callback: function($$v) {
              scope.row.port = $$v
            },
            expression: "scope.row.port"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.userName,
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "placeholder": _vm.attrText.usernameholder
          },
          model: {
            value: (scope.row.username),
            callback: function($$v) {
              scope.row.username = $$v
            },
            expression: "scope.row.username"
          }
        })]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$route.query.type == 'rds') ? _c('el-table', {
    staticClass: "instance-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.instanceList,
      "max-height": "400"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45",
      "fixed": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.instanceIdAndName,
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": scope.row.instance_name
          }
        }, [_c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.instance_name))])]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": scope.row.instance_id
          }
        }, [_c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.instance_id))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.type,
      "prop": "engine",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.IPAndAddress,
      "prop": "ip_address",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": scope.row.ip_address
          }
        }, [_c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.ip_address))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.port,
      "prop": "port",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          model: {
            value: (scope.row.port),
            callback: function($$v) {
              scope.row.port = $$v
            },
            expression: "scope.row.port"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.dataBase,
      "prop": "database",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          model: {
            value: (scope.row.database),
            callback: function($$v) {
              scope.row.database = $$v
            },
            expression: "scope.row.database"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.connectIdentifier,
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.engine === 'Oracle') ? _c('el-input', {
          model: {
            value: (scope.row.service_name),
            callback: function($$v) {
              scope.row.service_name = $$v
            },
            expression: "scope.row.service_name"
          }
        }) : _c('span', [_vm._v("-")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.connectIdentifierType,
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.engine === 'Oracle') ? _c('el-select', {
          model: {
            value: (scope.row.service_name_type),
            callback: function($$v) {
              scope.row.service_name_type = $$v
            },
            expression: "scope.row.service_name_type"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "Service Name",
            "value": "service_name"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "SID",
            "value": "sid"
          }
        })], 1) : _c('span', [_vm._v("-")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.userName,
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          model: {
            value: (scope.row.username),
            callback: function($$v) {
              scope.row.username = $$v
            },
            expression: "scope.row.username"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.password,
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "password"
          },
          model: {
            value: (scope.row.password),
            callback: function($$v) {
              scope.row.password = $$v
            },
            expression: "scope.row.password"
          }
        })]
      }
    }])
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.importLoading),
      expression: "importLoading"
    }],
    attrs: {
      "type": "primary",
      "disabled": !_vm.isCanImport
    },
    on: {
      "click": function($event) {
        _vm.onStartImport()
      }
    }
  }, [_c('translate', [_vm._v("Import")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cc8805d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/cluster-ak-import.vue
// module id = 535
// module chunks = 4 5 6